import axios from 'axios'
import moment from 'moment'
import AscentiaService from './ascentiaService'

const values = {
  phmAlerts: null,
}

const getters = {
  phmAlerts(phmAlertParams) {
    let url = ''
    if (phmAlertParams.endDate) {
      const startDate = moment(phmAlertParams.endDate)
        .subtract(3, 'months')
        .format('YYYY-MM-DD')
      const endDate = moment(phmAlertParams.endDate).format('YYYY-MM-DD')
      url = `/MaintenanceIssue/${phmAlertParams.issueId}/Alerts?startDate=${startDate}&endDate=${endDate}`
    } else {
      // if no date params, just get all the alerts
      url = `/MaintenanceIssue/${phmAlertParams.issueId}/Alerts`
    }
    return axios.get(url)
  },
}

export default class PHMAlertService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
